import React, { ReactNode } from 'react';

import clsx from 'clsx';

type CheckboxProps = {
  id: string;
  'data-testid': string;
  label: ReactNode;
  className?: string;
} & React.ComponentPropsWithoutRef<'input'>;

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ id, label, className, ...inputProps }, ref) => {
    return (
      <div className={clsx('flex', className)}>
        <input
          id={id}
          type="checkbox"
          ref={ref}
          className="cursor-pointer appearance-none w-5 h-5 border border-grey-70 rounded-sm text-2xl before:pl-[2.5px] checked:bg-teal-5 checked:before:content-[url(/icons/checkboxIcon.svg)] before:w-5 before:block"
          {...inputProps}
        />
        <label className="ml-2 cursor-pointer" htmlFor={id}>
          {label}
        </label>
      </div>
    );
  }
);

Checkbox.displayName = 'Checkbox';
